var map = {
	"./bg-header": "./app/webpacker/images/bg-header.jpg",
	"./bg-header.jpg": "./app/webpacker/images/bg-header.jpg",
	"./bg-header.webp": "./app/webpacker/images/bg-header.webp",
	"./favicon": "./app/webpacker/images/favicon.png",
	"./favicon.png": "./app/webpacker/images/favicon.png",
	"./footer": "./app/webpacker/images/footer.svg",
	"./footer.svg": "./app/webpacker/images/footer.svg",
	"./header": "./app/webpacker/images/header.svg",
	"./header.svg": "./app/webpacker/images/header.svg",
	"./image-wrapper": "./app/webpacker/images/image-wrapper.svg",
	"./image-wrapper.svg": "./app/webpacker/images/image-wrapper.svg",
	"./logo-lucasistencia": "./app/webpacker/images/logo-lucasistencia.png",
	"./logo-lucasistencia-square": "./app/webpacker/images/logo-lucasistencia-square.png",
	"./logo-lucasistencia-square.png": "./app/webpacker/images/logo-lucasistencia-square.png",
	"./logo-lucasistencia-white": "./app/webpacker/images/logo-lucasistencia-white.png",
	"./logo-lucasistencia-white.png": "./app/webpacker/images/logo-lucasistencia-white.png",
	"./logo-lucasistencia.jpg": "./app/webpacker/images/logo-lucasistencia.jpg",
	"./logo-lucasistencia.png": "./app/webpacker/images/logo-lucasistencia.png",
	"./maquinas-de-cafe": "./app/webpacker/images/maquinas-de-cafe.jpg",
	"./maquinas-de-cafe.jpg": "./app/webpacker/images/maquinas-de-cafe.jpg",
	"./navPanel": "./app/webpacker/images/navPanel.svg",
	"./navPanel.svg": "./app/webpacker/images/navPanel.svg",
	"./overlay": "./app/webpacker/images/overlay.png",
	"./overlay.png": "./app/webpacker/images/overlay.png",
	"./pic01": "./app/webpacker/images/pic01.jpg",
	"./pic01.jpg": "./app/webpacker/images/pic01.jpg",
	"./pic02": "./app/webpacker/images/pic02.jpg",
	"./pic02.jpg": "./app/webpacker/images/pic02.jpg",
	"./pic03": "./app/webpacker/images/pic03.jpg",
	"./pic03.jpg": "./app/webpacker/images/pic03.jpg",
	"./pic04": "./app/webpacker/images/pic04.jpg",
	"./pic04.jpg": "./app/webpacker/images/pic04.jpg",
	"./pic05": "./app/webpacker/images/pic05.jpg",
	"./pic05.jpg": "./app/webpacker/images/pic05.jpg",
	"./pic06": "./app/webpacker/images/pic06.jpg",
	"./pic06.jpg": "./app/webpacker/images/pic06.jpg",
	"./pic07": "./app/webpacker/images/pic07.jpg",
	"./pic07.jpg": "./app/webpacker/images/pic07.jpg",
	"./productos": "./app/webpacker/images/productos.jpg",
	"./productos.jpg": "./app/webpacker/images/productos.jpg",
	"./promo": "./app/webpacker/images/promo.jpg",
	"./promo.jpg": "./app/webpacker/images/promo.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/webpacker/images sync recursive ^\\.\\/.*$";